var ECM = (window.ECM = window.ECM || {});
(function ($, ECM) {
    ECM.initSteam = function (customerId) {
        var eventProxy = $('body'); 
        if (!$.connection || !$.connection.hub) {
            console.error("SignalR proxy not available. ");
            return;
        }
        $.connection.hub.logging = (document.location && document.location.hostname == "localhost");

        var hub = $.connection.EcmHub;

        hub.client.onCustomerConfermedSubscriptionLink = function (id) {
            if (id == customerId) {
                eventProxy.trigger('customer-confirmed', customerId);
            }

        };
        var opts = {}; //{ transport: ['longPolling' ,'webSockets']};
        connecting = $.connection.hub.start(opts).done(function () {
            // ready
            // hub.server 
            hub.server.hasCustomerConfirmed(customerId)
                .done(function (ok) {
                    if (ok) {
                        eventProxy.trigger('customer-confirmed', customerId);
                    } else {
                        console.warn("Customer not yet confirmed")
                    }
                });

        });
        return eventProxy;
    };

})(jQuery, ECM);

